import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[120px] w-full resize-y rounded-md border border-line-strong bg-surface px-3 py-2.5 text-base leading-6 text-ink placeholder:text-ink-muted aria-[invalid=true]:border-2 aria-[invalid=true]:border-sev-high disabled:cursor-not-allowed disabled:bg-sunken disabled:text-ink-muted",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
